<template>
	<div class="drag-input" @mousedown="dragStart" :title="label">
	<icon v-if="icon" :name="icon" size="12"/>
		{{label}}
		{{value}}
	</div>
</template>
<script>
	export default {
		name:"drag-input",
		props:{
			value:{
				type:Number,
				default:0
			},
			icon:String,
			label:String,
			min: {
				type:Number,
				default: -999999999
			},
			max: {
				type:Number,
				default: 999999999
			}
		},
		methods:{
			onMove(e){
				let value = this.startValue + e.screenX - this.startX;
				if(value<this.min) value = this.min;
				if(value>this.max) value = this.max;
				this.$emit('input', value);
			},
			dragStart(e){
				document.addEventListener('mousemove', this.onMove);
				document.addEventListener('mouseup', this.dragStop);
				this.startX = e.screenX;
				this.startValue = this.value;
			},
			dragStop(e){
				document.removeEventListener('mousemove', this.onMove);
				document.removeEventListener('mouseup', this.dragStop);
				//console.log(e);
			},
		},
		data(){
			return {
				startX:0,
				startY:0
			}
		}
	}
</script>
<style scoped>
	.drag-input{
		display: inline-block;
		padding:4px;
		border:1px solid lightgrey;
		border-radius: 2px;
		cursor: ew-resize;
		font-size:12px;
		margin:0px;
		vertical-align: top;
	}
</style>